import { render, staticRenderFns } from "./SheetTeacherItemRegister.vue?vue&type=template&id=4608a687&scoped=true"
import script from "./SheetTeacherItemRegister.vue?vue&type=script&lang=js"
export * from "./SheetTeacherItemRegister.vue?vue&type=script&lang=js"
import style0 from "./SheetTeacherItemRegister.vue?vue&type=style&index=0&id=4608a687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608a687",
  null
  
)

export default component.exports